import "./DesignUpdater.scss";
import {useRecoilValue} from "recoil";
import {memberState, posState} from "../../state/atoms";
import React, {useEffect, useState } from "react";
import MenuManagement from "../../img/MenuManagement.mp4";
import ToastDesignUpdater from "../pos/ToastDesignUpdater";
import CloverDesignUpdater from "../pos/CloverDesignUpdater";
import SquareDesignUpdater from "../pos/SquareDesignUpdater";
import { env } from "../../env/env";
import TreezDesignUpdater from "../pos/TreezDesignUpdater";
import PopmenuDesignUpdater from "../pos/PopmenuDesignUpdater";

interface DesignUpdaterProps {
  loading: boolean
}

export default function DesignUpdater({loading}: DesignUpdaterProps) {
  const pos = useRecoilValue(posState);
  const member = useRecoilValue(memberState);

  const [showToast, setShowToast] = useState(false);
  const [showClover, setShowClover] = useState(false);
  const [showSquare, setShowSquare] = useState(false);
  const [showTreez, setShowTreez] = useState(false);
  const [showPopmenu, setShowPopmenu] = useState(false);
  const [showDefault, setShowDefault] = useState(false);

  useEffect(() => {
    setShowToast(pos.enabled && pos.isToast && !member.clover && !pos.isSquare && !pos.isTreez && !pos.isPopmenu);
    setShowClover(pos.enabled && pos.isClover && member.clover && !pos.isSquare && !pos.isTreez && !pos.isPopmenu);
    setShowSquare(pos.enabled && pos.isSquare);
    setShowTreez(pos.enabled && pos.isTreez);
    setShowPopmenu(pos.enabled && pos.isPopmenu);
    setShowDefault(pos.enabled && !pos.isToast && !pos.isClover && !pos.isSquare && !pos.isTreez && !pos.isPopmenu);
  }, [member.clover, pos.enabled, pos.isToast, pos.isClover, pos.isSquare, pos.isTreez, pos.isPopmenu]);

  return <div>
    <h6 style={{
      fontSize: "17px",
      color: "#e42436"
    }}>NOTE: Page to be discontinued in April, 2025. If this will cause inconvenience, please send a note via chat.</h6>

    <h3 className={'design-updated-header'}>POS Integration</h3>

    {showToast && <ToastDesignUpdater loading={loading}/>}
    {showClover && <CloverDesignUpdater loading={loading}/>}
    {showSquare && <SquareDesignUpdater loading={loading}/>}
    {showTreez && <TreezDesignUpdater loading={loading}/>}
    {showPopmenu && <PopmenuDesignUpdater loading={loading}/>}
    {showDefault && <section className={"updater-soon"}>
      <div className="flex">
        <div className={"banner"}>
          <video loop autoPlay muted playsInline>
            <source src={MenuManagement} type="video/mp4"/>
          </video>
        </div>
        <div className={"updater"}>
          <h3>
            Menu Management Made Easy
          </h3>
          <p>
            POS Integration allows you to keep your designs synced with any changes to your original POS data.
            <br/><br/>
            Currently available for Toast and Square.
          </p>
          <a href={`${env.timberContextPath}/design?size=menu-letter&open=integration`}
             className="ant-btn ant-btn-primary">Link your POS account</a>
        </div>
      </div>
    </section>}
  </div>
}
